import { render, staticRenderFns } from "./PaymentStatement.vue?vue&type=template&id=f013f5fe&scoped=true"
import script from "./PaymentStatement.vue?vue&type=script&lang=js"
export * from "./PaymentStatement.vue?vue&type=script&lang=js"
import style0 from "./PaymentStatement.vue?vue&type=style&index=0&id=f013f5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f013f5fe",
  null
  
)

export default component.exports